import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function doctorRetrieve(doctorId) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_RETRIEVE_REQUESTED,
      ACTION_TYPES.DOCTOR_RETRIEVE_SUCCEED,
      ACTION_TYPES.DOCTOR_RETRIEVE_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function doctorFeeUpdate(doctorId, body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_FEE_UPDATE_REQUESTED,
      ACTION_TYPES.DOCTOR_FEE_UPDATE_SUCCEED,
      ACTION_TYPES.DOCTOR_FEE_UPDATE_FAILED,
    ],
    promise: client => client.post(`/doctors/${doctorId}/fee-setting`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function doctorFeeGet(doctorId) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_FEE_RETRIEVE_REQUESTED,
      ACTION_TYPES.DOCTOR_FEE_RETRIEVE_SUCCEED,
      ACTION_TYPES.DOCTOR_FEE_RETRIEVE_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/fee-settings`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function doctorAvailableUpdate({ doctorId, available }) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_CHAT_AVAILABLE_UPDATE_REQUESTED,
      ACTION_TYPES.DOCTOR_CHAT_AVAILABLE_UPDATE_SUCCEED,
      ACTION_TYPES.DOCTOR_CHAT_AVAILABLE_UPDATE_FAILED,
    ],
    promise: client =>
      client.post(`/doctors/${doctorId}/service-activation`, {
        available,
      }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function doctorGetCurrencies() {
  return {
    types: [
      ACTION_TYPES.WEBCHAT_DOCTOR_GET_CURRENCIES_REQUESTED,
      ACTION_TYPES.WEBCHAT_DOCTOR_GET_CURRENCIES_SUCCEED,
      ACTION_TYPES.WEBCHAT_DOCTOR_GET_CURRENCIES_FAILED,
    ],
    promise: client => client.get('/configs/currencies'),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function doctorCurrencyUpdate(doctorId, body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_CURRENCY_UPDATE_REQUESTED,
      ACTION_TYPES.DOCTOR_CURRENCY_UPDATE_SUCCEED,
      ACTION_TYPES.DOCTOR_CURRENCY_UPDATE_FAILED,
    ],
    promise: client => client.patch(`/doctors/${doctorId}/currencies`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function doctorSetPriorityQueueFee(doctorId, priorityQueueFee) {
  return {
    types: [
      ACTION_TYPES.WEBCHAT_DOCTOR_SET_PRIORITY_FEE_REQUESTED,
      ACTION_TYPES.WEBCHAT_DOCTOR_SET_PRIORITY_FEE_SUCCEED,
      ACTION_TYPES.WEBCHAT_DOCTOR_SET_PRIORITY_FEE_FAILED,
    ],
    promise: client => client.post(`/doctors/${doctorId}/priority-queue-fee`, { priorityQueueFee }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function doctorGetWorkingTimes(doctorId) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_GET_WORKING_TIMES_REQUESTED,
      ACTION_TYPES.DOCTOR_GET_WORKING_TIMES_SUCCEED,
      ACTION_TYPES.DOCTOR_GET_WORKING_TIMES_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/working-times`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function doctorSetWorkingTimes(doctorId, body) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_SET_WORKING_TIMES_REQUESTED,
      ACTION_TYPES.DOCTOR_SET_WORKING_TIMES_SUCCEED,
      ACTION_TYPES.DOCTOR_SET_WORKING_TIMES_FAILED,
    ],
    promise: client => client.post(`/doctors/${doctorId}/working-times`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}
